import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";
import DateCard from "./component/DateCard";
import TimeslotCard from "./component/TimeslotCard";

//Assets
import ScheduledIcon from "../../../../images/scheduled.png";

//Interfaces
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  loading,
  selectedTime,
  cardList,
  timeslotList,
  timezone,
  isActiveTimeHandler,
  isActiveCardHandler,
  selectDateHandler,
  onBack,
  createPickupRequestHandler,
  selectTimeHandler
}) => {
  return (
    <CustomBody loading={loading} withBack backAction={onBack}>
      <div className="pickup-scheduled-body">
        <KickImage className="scheduled-icon" src={ScheduledIcon} alt="pickup-address" />
        <p className="header">Pick-up Order Created</p>
        <p className="description">
          Any pick-ups after 12.00 WIB (Express) and <br />
          18.00 WIB (Regular) will potentially be delivered <br />
          up to one day after the estimated time of arrival.
        </p>

        <DateCard
          cardList={cardList}
          isActiveCardHandler={isActiveCardHandler}
          selectDateHandler={selectDateHandler}
        />
        <TimeslotCard 
          timeslotList={timeslotList}
          timezone={timezone}
          isActiveTimeHandler={isActiveTimeHandler}
          selectTimeHandler={selectTimeHandler}
        />

        <CustomButton
          text="Confirm"
          disabled={!selectedTime.key}
          onClick={() => createPickupRequestHandler()}
        />
      </div>
    </CustomBody>
  )
}
export default Component;